import React, { useState, useEffect } from "react";
import { Col, FloatingLabel, Form, Row } from "react-bootstrap";
import { unsavedChanges } from "../../App";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tooltip";

interface MeetingNoteState {
  participant: any;
  index: number;
  participants: any[];
  setParticipants: any;
  attendanceStats: any;
  setEnableSave: any;
  meetingDate: string;
  readOnly?: boolean;
}

const GroupMeetingIndivNote = ({
  participant,
  index,
  participants,
  setParticipants,
  attendanceStats,
  setEnableSave,
  meetingDate,
  readOnly = false,
}: MeetingNoteState) => {
  const [note, setNote] = useState<string>("");
  const [isPresent, setIsPresent] = useState<boolean>(true);

  useEffect(() => {
    if (participant) {
      setNote(participant.note || "");
      setIsPresent(!!participant.is_present); 
    }
  }, [participant]);

  const updateNote = (e: any) => {
    const newNoteValue = e.target.value;
    setNote(newNoteValue);
    const updatedParticipants = [...participants];
    updatedParticipants[index] = { ...participant, note: newNoteValue };
    setParticipants(updatedParticipants);
    unsavedChanges.value = true;

    if (meetingDate) {
      setEnableSave(true);
    }
  };

  const updateAttendance = () => {
    const presence = !isPresent;
    setIsPresent(presence);
    const updatedParticipants = [...participants];
    updatedParticipants[index] = { ...participant, is_present: presence };
    setParticipants(updatedParticipants);
    unsavedChanges.value = true;
  };

  const setTooltipText = () => {
    const attended = attendanceStats?.attended ?? 0;
    const total = attendanceStats?.total ?? 0;
    const tooltipText = total > 0 ? `Attended ${attended} out of ${total} meetings` : "No previous meetings attended";
    return tooltipText;
  };

  return (
    <Row>
      <Col className="col-9">
        <FloatingLabel
          controlId="floatingInput"
          label={`${participant.firstname} ${participant.lastname} ${isPresent ? "" : "Absent"} Note`}
          className="sm mb-2 mt-1"
        >
          <Form.Control
            type="text"
            placeholder="Note"
            value={note}
            onChange={(e) => updateNote(e)}
            disabled={readOnly}
          />
        </FloatingLabel>
      </Col>
      <Col>
        <Form.Group key={`default-checkbox`} className="mb-1">
          <label className="d-flex align-items-center gap-1">
            <Form.Check
              onChange={updateAttendance}
              type="checkbox"
              id={`default-checkbox-${index}`}
              checked={isPresent}
              key="Present"
              className="me-2"
              disabled={readOnly}
              label="Present"
            />
            {!readOnly && (
              <FontAwesomeIcon
                data-tooltip-id="attendance-tooltip"
                data-tooltip-content={setTooltipText()}
                icon={faInfoCircle}
                className="opacity-75 app-primary-color-inverse cursor-pointer"
                fontSize={14}
              />
            )}
          </label>
          <Tooltip id="attendance-tooltip" style={{ zIndex: 1000 }} />
        </Form.Group>
      </Col>
    </Row>
  );
};

export default GroupMeetingIndivNote;
